import React from "react";
import EyeIcon from "../icons/EyeIcon";
import SendIcon from "../icons/SendIcon";
import { MenuJsonItem } from "@/types/types";
import { getImageUrl } from "@/utilities/menu";
import CuisineTypes from "../cuisine-types/CuisineTypes";

interface MenusProps {
  menus: MenuJsonItem[];
}

const Menus: React.FC<MenusProps> = ({ menus }) => {
  return (
    <>
      {menus?.length ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {menus.map((menu: MenuJsonItem, index: number) => (
            <div
              key={index}
              className="max-w-sm rounded overflow-hidden shadow-lg bg-white"
            >
              <a
                href={`/restaurant/${encodeURIComponent(menu.name)}/`}
                title={menu.name}
                className="block"
              >
                {menu.image ? (
                  <img
                    src={getImageUrl(menu.image)}
                    alt={menu.name}
                    width={400}
                    height={300}
                    className="w-full max-h-[145.77px] object-cover"
                  />
                ) : null}
                <div className="px-6 pt-4">
                  <h3 className="font-bold text-xl capitalize">
                    {menu.name.replace(/-/g, " ")}
                  </h3>
                </div>
              </a>
              <div className="px-6 pt-2 pb-4">
                <CuisineTypes types={menu?.cuisineType || []} />
                <p className="text-xs text-gray-500 leading-snug mb-3 text-left">
                  <a
                    className="inline-block gap-[4px] hover:text-black"
                    target="_blank"
                    rel="noopener noreferrer"
                    title={menu.address}
                    href={
                      menu.mapUrl
                        ? menu.mapUrl
                        : `https://maps.google.com/maps?f=q&hl=fr&q=${encodeURIComponent(
                            menu.address
                          )}&ie=UTF8`
                    }
                  >
                    <SendIcon />
                    <span className="inline-block ml-1">{menu.address}</span>
                  </a>
                  {menu.city ? (
                    <>
                      <span>,&nbsp;</span>
                      <a
                        title={menu.name + " " + menu.city}
                        className="inline-block hover:text-black"
                        href={`${
                          process.env.NEXT_PUBLIC_URL
                        }/restaurants/${menu.country
                          ?.replaceAll(" ", "-")
                          ?.toLocaleLowerCase()}/${menu.city
                          ?.replaceAll(" ", "-")
                          ?.toLocaleLowerCase()}/`}
                      >
                        {menu.city}
                      </a>
                    </>
                  ) : null}
                  {menu.zipCode ? <>,&nbsp;{menu.zipCode}</> : ""}
                  {menu.state ? <>,&nbsp;{menu.state}</> : ""}
                  {menu.country ? (
                    <>
                      <span>,&nbsp;</span>
                      <a
                        title={menu.name + " " + menu.country}
                        className="inline-block hover:text-black"
                        href={`${
                          process.env.NEXT_PUBLIC_URL
                        }/restaurants/${menu.country
                          ?.replaceAll(" ", "-")
                          ?.toLocaleLowerCase()}/`}
                      >
                        {menu.country}
                      </a>
                    </>
                  ) : null}
                </p>
                <p className="text-[#757575] text-[14px] mb-1">
                  {`QR Menu ${
                    menu?.industry?.replaceAll("-", " ") || "restaurant"
                  } in ${menu.city}`}
                </p>
                <p className="text-[#757575] text-[12px]">
                  View the menu for {menu.name}’s on qr menu for delivery,
                  dine-out or takeaway.
                </p>
                {menu?.vue ? (
                  <div className="text-black text-[12px] font-bold text-right mt-5 flex items-end justify-end gap-[6px]">
                    <EyeIcon />
                    <span>Vue : {menu.vue}</span>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <img
          src={"/images/no_result_found.gif"}
          alt="no result found qrmenu"
          className="w-full max-w-[700px] mx-auto object-fit"
        />
      )}
    </>
  );
};

export default Menus;
